import React from 'react'

import Base from '../_Base'

const Email = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.3999 6.60078C2.3999 5.60718 3.26006 4.80078 4.3199 4.80078H19.6799C20.7397 4.80078 21.5999 5.60718 21.5999 6.60078V17.4008C21.5999 18.3944 20.7397 19.2008 19.6799 19.2008H4.3199C3.26006 19.2008 2.3999 18.3944 2.3999 17.4008V6.60078ZM11.9999 13.8314L19.6799 9.03078V6.86778L11.9999 11.6678L4.3199 6.86778V9.03078L11.9999 13.8314Z"
    />
  </Base>
)

export default Email
